import { motion } from 'framer-motion';

import { Typography } from '../typography';

const Logo = () => {
	return (
		<>
			<motion.div
				animate={{ x: ['-14.0%', '14.0%'] }}
				transition={{ duration: 12, repeat: Infinity, repeatType: 'mirror' }}
			>
				<Typography weight="thin" lineHeight={0.8} size="m">
					THINK
				</Typography>
			</motion.div>
			<motion.div
				animate={{ x: ['4.0%', '-4.0%'] }}
				transition={{ duration: 17, repeat: Infinity, repeatType: 'mirror' }}
			>
				<Typography weight="bold" lineHeight={0.8} size="m">
					AGAIN.
				</Typography>
			</motion.div>
		</>
	);
};

export default Logo;
